import { createI18n } from 'vue-i18n';
import { getLocale } from '@/utils/locale';
import { slavicPluralization } from '@/utils/slavicPluralization';

const messages = {
  ru: {
    orgDoesNotExist: 'Организация не существует',
    linkIsNotValid: 'Ссылка не действительна',
    emailChangeLinkIsNotValid: 'Ссылка больше не действует. Запросите смену почты ещё раз.',
    controllerNotFound: 'Контроллер не найден',
    controllerLoadError: 'Произошла ошибка, повторите позже',
    moreInDocs: 'Подробнее в документации',
    roles: {
      member: 'Пользователь',
      admin: 'Админ',
      owner: 'Владелец',
      demo: 'Демо',
    },
    roleActions: {
      controllersConfigure: 'Настройка, подключение и удаление контроллеров',
      controllersMove: 'Перенос контроллеров',
      membersInvite: 'Приглашение и удаление пользователей',
      adminsAssign: 'Назначение и снятие админов',
      organizationSettings: 'Переименование организации и требование 2FA',
      organizationDelete: 'Удаление организации',
    },
  },
  en: {
    orgDoesNotExist: 'Organization does not exist',
    linkIsNotValid: 'Link is not valid',
    emailChangeLinkIsNotValid: 'This link is no longer valid. Request the email change again.',
    controllerNotFound: 'Controller not found',
    controllerLoadError: 'An error occurred, please try again later',
    moreInDocs: 'More in the documentation',
    roles: {
      member: 'Member',
      admin: 'Admin',
      owner: 'Owner',
      demo: 'Demo',
    },
    roleActions: {
      controllersConfigure: 'Configure, access and delete controllers',
      controllersMove: 'Move controllers',
      membersInvite: 'Invite and remove members',
      adminsAssign: 'Assign and remove admins',
      organizationSettings: 'Rename organization and require 2FA',
      organizationDelete: 'Delete organization',
    },
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  pluralRules: {
    ru: slavicPluralization,
  },
  messages,
});
